module.exports = __webpack_public_path__ + "static/media/DSC_0204.4271f1f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0204.jpg
// module id = 645
// module chunks = 0